import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";

import React from "react";
// import CategoryTopbar from "../../features/manageCategories/topbar";
// import CategoryList from "../../features/manageCategories/categoryList";

const ManageAmenities = () => {
  const navigate = useNavigate();
  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Manage Amenities</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> - Manage
          Amenities
        </p>
      </div>

      <div className="cards">
        {/* <CategoryTopbar />
        <CategoryList /> */}
      </div>
    </MainContainer>
  );
};

export default ManageAmenities;
